import { get } from './helpers'

export default {
  getSeats() {
    return get('api/seats')
  }
}
